/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateHandle.defs'
export { main as default } from './updateHandle.defs'
